import {
  HappycoUserFragment,
  HappycoUsersQuery,
  HappycoUsersQueryVariables,
} from "gql/graphql";
import React, { memo, useCallback, useMemo } from "react";
import { useQuery } from "@apollo/client";
import { Select, SingleValue } from "chakra-react-select";
import { SystemStyleObject } from "@chakra-ui/react";
import colors from "app/colors";
import HAPPYCO_USERS_QUERY from "./_networking/happyco-users";

interface IProps {
  onUserSelected: (happycoUser?: SingleValue<HappycoUserFragment>) => void;
}

const HappycoUserSelector = ({ onUserSelected }: IProps) => {
  const { data } = useQuery<HappycoUsersQuery, HappycoUsersQueryVariables>(
    HAPPYCO_USERS_QUERY,
  );

  const onChange = (happycoUser: SingleValue<HappycoUserFragment>) => {
    onUserSelected(happycoUser);
  };

  const getOptionLabel = useCallback(
    (happycoUser: HappycoUserFragment) => happycoUser.name,
    [],
  );

  const getOptionValue = useCallback(
    (happycoUser: HappycoUserFragment) => happycoUser.happycoId,
    [],
  );

  const happycoUsers = useMemo(() => data?.happycoUsers || [], [data]);

  return (
    <Select
      options={happycoUsers}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      placeholder="Select User"
      onChange={onChange}
      components={{
        DropdownIndicator: () => null,
        IndicatorSeparator: () => null,
      }}
      chakraStyles={{
        placeholder: (provided: SystemStyleObject): SystemStyleObject => ({
          ...provided,
          fontStyle: "italic",
          color: colors.placeholderText,
          fontSize: 14,
        }),
        container: (provided: SystemStyleObject): SystemStyleObject => ({
          ...provided,
          width: "full",
          borderColor: colors.grayPrimary,
        }),
        control: (provided: SystemStyleObject): SystemStyleObject => ({
          ...provided,
          minHeight: "34px",
        }),
      }}
    />
  );
};

export default memo(HappycoUserSelector);
